import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5%",
    flexGrow: 1,
  },
  createBtn: {
    marginBottom: "1%",
  },
  container: {
    marginTop: "1%",
  },
}));

export default useStyles;
